import { render, staticRenderFns } from "./callPhonePopUp.vue?vue&type=template&id=6bf5c382&scoped=true&"
import script from "./callPhonePopUp.vue?vue&type=script&lang=js&"
export * from "./callPhonePopUp.vue?vue&type=script&lang=js&"
import style0 from "./callPhonePopUp.vue?vue&type=style&index=0&id=6bf5c382&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5c382",
  null
  
)

export default component.exports